import React from "react";

// Safely encode JSON to avoid breaking </script>
const safeJsonLd = (json) => {
  return JSON.stringify(json).replace(/<\/script>/g, '<\\/script>');
};

const AboutMeStructuredData = ({
  name = "Alberto Lussana",
  url = "https://lussana.me",
  description,
  birthPlace = "Italy",
  nationality = "Italian",
  jobTitle = "Digital Marketer and Photographer",
  instagramUrl = "https://www.instagram.com/albertolussana/",
  linkedinUrl = "https://www.linkedin.com/in/albertolussana/",
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": name,
    "url": url,
    "description": description,
    "nationality": nationality,
    "birthPlace": {
      "@type": "Place",
      "name": birthPlace,
    },
    "jobTitle": jobTitle,
    "sameAs": [
      url,              // your website
      instagramUrl,     // Instagram profile
      linkedinUrl,      // LinkedIn profile
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJsonLd(schema) }}
    />
  );
};

export default AboutMeStructuredData;
